module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = "fslightbox-",
      o = "".concat(r, "styles"),
      i = "".concat(r, "cursor-grabbing"),
      a = "".concat(r, "full-dimension"),
      s = "".concat(r, "flex-centered"),
      c = "".concat(r, "open"),
      l = "".concat(r, "transform-transition"),
      u = "".concat(r, "absoluted"),
      d = "".concat(r, "fade-in"),
      f = "".concat(r, "fade-out"),
      p = d + "-strong",
      h = f + "-strong",
      g = "".concat(r, "opacity-1"),
      m = "".concat(r, "source"),
      v = "".concat(m, "-inner");

  function b() {
    var e = document.createElement("style");
    e.className = o, e.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .25s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .25s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .25s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .25s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px!important;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-previous-container{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-previous-container{padding-left:3px}}.fslightbox-slide-btn-next-container{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-next-container{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-next-container{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-next-container{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-loader{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightbox-loader div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightbox-loader 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightbox-loader .fslightbox-loader-child-1{animation-delay:-.45s}.fslightbox-loader .fslightbox-loader-child-2{animation-delay:-.3s}.fslightbox-loader .fslightbox-loader-child-3{animation-delay:-.15s}@keyframes fslightbox-loader{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0;transform:translateZ(0);margin:auto;backface-visibility:hidden}")), document.head.appendChild(e);
  }

  function x(e) {
    return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  "object" === ("undefined" == typeof document ? "undefined" : x(document)) && b();

  var y = n(0),
      S = n.n(y),
      w = n(1),
      L = n.n(w),
      A = function A(e) {
    var t = e.size,
        n = e.viewBox,
        o = e.d;
    return S.a.createElement("svg", {
      width: t,
      height: t,
      viewBox: n,
      xmlns: "http://www.w3.org/2000/svg"
    }, S.a.createElement("path", {
      className: "".concat(r, "svg-path"),
      d: o
    }));
  },
      E = function E(e) {
    var t = e.onClick,
        n = e.viewBox,
        o = e.size,
        i = e.d,
        a = e.title;
    return S.a.createElement("div", {
      onClick: t,
      className: "".concat(r, "toolbar-button ").concat(s),
      title: a
    }, S.a.createElement(A, {
      viewBox: n,
      size: o,
      d: i
    }));
  };

  function O(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return C(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return C(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function C(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var I = function I(e) {
    var t = e.fsLightbox,
        n = t.componentsServices.toolbarButtons.fullscreen,
        r = t.core.fullscreenToggler,
        o = r.enterFullscreen,
        i = r.exitFullscreen,
        a = O(Object(y.useState)(!1), 2),
        s = a[0],
        c = a[1];
    return n.get = function () {
      return s;
    }, n.set = c, S.a.createElement(E, {
      onClick: function onClick() {
        s ? i() : o();
      },
      viewBox: s ? "0 0 950 1024" : "0 0 18 18",
      size: s ? "24px" : "20px",
      d: s ? "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z" : "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",
      title: s ? "Exit fullscreen" : "Enter fullscreen"
    });
  },
      F = function F(e) {
    var t = e.fsLightbox.core.lightboxCloser.closeLightbox;
    return S.a.createElement(E, {
      onClick: t,
      viewBox: "0 0 24 24",
      size: "20px",
      d: "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z",
      title: "Close"
    });
  },
      T = function T(e) {
    var t = e.fsLightbox;
    return S.a.createElement("div", {
      className: "".concat(r, "toolbar")
    }, S.a.createElement(I, {
      fsLightbox: t
    }), S.a.createElement(F, {
      fsLightbox: t
    }));
  };

  function j(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return z(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return z(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function z(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var M = function M(e) {
    var t = e.fsLightbox,
        n = t.componentsServices,
        o = t.props.sources,
        i = t.stageIndexes,
        a = j(Object(y.useState)(i.current + 1), 2),
        s = a[0],
        c = a[1];

    n.setSlideNumber = function (e) {
      c(e);
    };

    var l = S.a.createRef(),
        u = S.a.createRef();
    return Object(y.useEffect)(function () {
      u.current.offsetWidth > 55 && (l.current.style.justifyContent = "flex-start");
    }, []), S.a.createElement("div", {
      ref: l,
      className: "".concat(r, "slide-number-container")
    }, S.a.createElement("div", {
      ref: u,
      className: "fslightbox-flex-centered"
    }, S.a.createElement("span", null, s), S.a.createElement("span", {
      className: "".concat(r, "slash")
    }), S.a.createElement("span", null, o.length)));
  },
      W = function W(e) {
    var t = e.fsLightbox;
    return S.a.createElement("div", {
      className: "".concat(r, "nav")
    }, S.a.createElement(T, {
      fsLightbox: t
    }), t.props.sources.length > 1 && S.a.createElement(M, {
      fsLightbox: t
    }));
  },
      k = function k() {
    return S.a.createElement("div", {
      className: "".concat(r, "loader")
    }, S.a.createElement("div", {
      className: "".concat(r, "loader-child-1")
    }), S.a.createElement("div", {
      className: "".concat(r, "loader-child-2")
    }), S.a.createElement("div", {
      className: "".concat(r, "loader-child-3")
    }), S.a.createElement("div", {
      className: "".concat(r, "loader-child-4")
    }));
  };

  function N(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return D(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return D(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function D(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var R = function R(e) {
    var t = e.fsLightbox,
        n = t.componentsServices.updateSourceDirectWrapperCollection,
        r = t.core.stageManager.isSourceInStage,
        o = t.elements,
        i = o.sourcesComponents,
        a = o.sourceAnimationWrappers,
        s = t.props.loadOnlyCurrentSource,
        c = t.stageIndexes.current,
        l = e.i,
        u = N(Object(y.useState)(!1), 2),
        d = u[0],
        f = u[1];
    return n[l] = function () {
      f(!d);
    }, S.a.createElement("div", {
      ref: a[l],
      className: v
    }, l === c || !s && r(l) ? i[l] : null);
  };

  function H(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return P(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return P(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function P(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var U = function U(e) {
    var t = e.fsLightbox,
        n = e.i,
        r = t.componentsServices.hideSourceLoaderCollection,
        o = t.elements.sourceMainWrappers,
        i = H(Object(y.useState)(!1), 2),
        c = i[0],
        l = i[1];
    return r[n] = function () {
      return l(!0);
    }, S.a.createElement("div", {
      ref: o[n],
      className: "".concat(u, " ").concat(a, " ").concat(s)
    }, !c && S.a.createElement(k, null), S.a.createElement(R, {
      fsLightbox: t,
      i: n
    }));
  },
      X = function X(e) {
    for (var t = e.fsLightbox, n = t.core.slideSwipingDown.listener, r = t.elements.sourceMainWrappersWrapper, o = t.props.sources, i = [], s = 0; s < o.length; s++) {
      i.push(S.a.createElement(U, {
        fsLightbox: t,
        i: s,
        key: s
      }));
    }

    return S.a.createElement("div", {
      className: "".concat(u, " ").concat(a),
      ref: r,
      onMouseDown: n,
      onTouchStart: n
    }, i);
  };

  function B(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return V(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return V(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function V(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var _ = function _(e) {
    var t = e.fsLightbox.componentsServices,
        n = B(Object(y.useState)(!1), 2),
        o = n[0],
        i = n[1];
    return t.showSlideSwipingHovererIfNotYet = function () {
      o || i(!0);
    }, t.hideSlideSwipingHovererIfShown = function () {
      o && i(!1);
    }, o && S.a.createElement("div", {
      className: "".concat(r, "slide-swiping-hoverer ").concat(a, " ").concat(u)
    });
  };

  function Y(e) {
    var t = e.props.disableLocalStorage;

    if (!t) {
      var n = localStorage.getItem("fslightbox-scrollbar-width");
      if (n) return n;
    }

    var r = function () {
      var e = document.createElement("div"),
          t = e.style;
      return t.visibility = "hidden", t.width = "100px", t.msOverflowStyle = "scrollbar", t.overflow = "scroll", e;
    }(),
        o = function () {
      var e = document.createElement("div");
      return e.style.width = "100%", e;
    }();

    document.body.appendChild(r);
    var i = r.offsetWidth;
    r.appendChild(o);
    var a = o.offsetWidth;
    document.body.removeChild(r);
    var s = i - a;
    return t || localStorage.setItem("fslightbox-scrollbar-width", s.toString()), s;
  }

  function q(e) {
    var t = e.core.lightboxOpener,
        n = e.data,
        r = e.props.openOnMount;
    document.getElementsByClassName(o).length || b(), n.scrollbarWidth = Y(e), r && t.initializeAndOpenLightbox();
  }

  var $ = function $(e) {
    var t = e.onClick,
        n = e.name,
        o = e.d,
        i = n.charAt(0).toUpperCase() + n.slice(1),
        a = "".concat(r, "slide-btn");
    return S.a.createElement("div", {
      onClick: t,
      title: "".concat(i, " slide"),
      className: "".concat(a, "-container ").concat(a, "-").concat(n, "-container")
    }, S.a.createElement("div", {
      className: "".concat(a, " ").concat(s)
    }, S.a.createElement(A, {
      viewBox: "0 0 20 20",
      size: "20px",
      d: o
    })));
  };

  function Q(e) {
    var t = e.componentsServices.isLightboxOpenManager,
        n = e.core,
        r = n.lightboxCloser,
        o = n.lightboxOpener,
        i = n.slideIndexChanger,
        a = e.data,
        s = e.stageIndexes;
    this.runTogglerUpdateActions = function () {
      t.get() ? r.closeLightbox() : a.isInitialized ? o.openLightbox() : o.initializeAndOpenLightbox();
    }, this.runCurrentStageIndexUpdateActionsFor = function (e) {
      e !== s.current && (t.get() ? i.jumpTo(e) : s.current = e);
    };
  }

  function J(e) {
    var t = e.core.lightboxUpdater,
        n = (0, e.resolve)(Q);

    t.handleUpdate = function (t) {
      var r = e.props;
      void 0 !== r.source ? n.runCurrentStageIndexUpdateActionsFor(r.sources.indexOf(r.source)) : void 0 !== r.sourceIndex ? n.runCurrentStageIndexUpdateActionsFor(r.sourceIndex) : void 0 !== r.slide && n.runCurrentStageIndexUpdateActionsFor(r.slide - 1), t.toggler !== r.toggler && n.runTogglerUpdateActions();
    };
  }

  function G(e) {
    var t,
        n = e.props,
        r = 0,
        o = {};
    this.getSourceTypeFromLocalStorageByUrl = function (e) {
      return t[e] ? t[e] : i(e);
    }, this.handleReceivedSourceTypeForUrl = function (e, n) {
      !1 === o[n] && (r--, "invalid" !== e ? o[n] = e : delete o[n], 0 === r && (!function (e, t) {
        for (var n in t) {
          e[n] = t[n];
        }
      }(t, o), localStorage.setItem("fslightbox-types", JSON.stringify(t))));
    };

    var i = function i(e) {
      r++, o[e] = !1;
    };

    n.disableLocalStorage ? (this.getSourceTypeFromLocalStorageByUrl = function () {}, this.handleReceivedSourceTypeForUrl = function () {}) : (t = JSON.parse(localStorage.getItem("fslightbox-types"))) || (t = {}, this.getSourceTypeFromLocalStorageByUrl = i);
  }

  function Z() {
    return (Z = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var K = function K(e) {
    var t = e.fsLightbox,
        n = t.collections.sourceLoadHandlers,
        r = t.elements.sources,
        o = t.props,
        i = o.customAttributes,
        a = o.sources,
        s = e.i;
    return S.a.createElement("img", Z({
      onLoad: n[s].handleImageLoad,
      className: m,
      ref: r[s],
      src: a[s]
    }, i && i[s] ? i[s] : {}));
  };

  function ee() {
    return (ee = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var te = function te(e) {
    var t = e.fsLightbox,
        n = t.collections.sourceLoadHandlers,
        o = t.elements.sources,
        i = t.props,
        a = i.customAttributes,
        s = i.sources,
        c = t.timeout,
        l = e.i;
    return c(n[l].handleNotMetaDatedVideoLoad, 3e3), S.a.createElement("video", ee({
      onLoadedMetadata: n[l].handleVideoLoad,
      className: "".concat(m, " ").concat(r, "video"),
      controls: !0,
      ref: o[l]
    }, a && a[l] ? a[l] : {}), S.a.createElement("source", {
      src: s[l]
    }));
  };

  function ne() {
    return (ne = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var re = function re(e) {
    var t,
        n = e.fsLightbox,
        o = n.elements.sources,
        i = n.collections.sourceLoadHandlers,
        a = n.props,
        s = a.customAttributes,
        c = a.sources,
        l = e.i;
    return Object(y.useEffect)(i[l].handleYoutubeLoad), S.a.createElement("iframe", ne({
      ref: o[l],
      className: "".concat(m, " ").concat(r, "youtube-iframe"),
      src: "https://www.youtube.com/embed/".concat((t = c[l], t.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2])),
      allowFullScreen: !0
    }, s && s[l] ? s[l] : {}));
  },
      oe = function oe(e) {
    var t = e.fsLightbox,
        n = t.componentsServices.hideSourceLoaderCollection,
        o = t.elements.sourceMainWrappers,
        i = e.i;
    return Object(y.useEffect)(function () {
      n[i](), o[i].current.classList.add(p);
    }), S.a.createElement("div", {
      className: "".concat(r, "invalid-file-wrapper ").concat(s)
    }, "Invalid source");
  },
      ie = function ie(e) {
    var t = e.fsLightbox,
        n = t.collections.sourceLoadHandlers,
        r = t.elements.sources,
        o = t.props.sources,
        i = e.i;
    Object(y.useEffect)(n[i].handleCustomLoad);
    var a = o[i].props.className;
    return S.a.cloneElement(o[i], {
      ref: r[i],
      className: a ? "".concat(a, " ").concat(m) : m
    });
  };

  function ae(e) {
    var t = e.componentsServices,
        n = t.isLightboxOpenManager,
        r = t.updateSourceDirectWrapperCollection,
        o = e.elements.sourcesComponents;

    this.runActionsForSourceTypeAndIndex = function (t, i) {
      var a;

      switch (t) {
        case "image":
          a = K;
          break;

        case "video":
          a = te;
          break;

        case "youtube":
          a = re;
          break;

        case "custom":
          a = ie;
          break;

        default:
          a = oe;
      }

      o[i] = S.a.createElement(a, {
        fsLightbox: e,
        i: i
      }), n.get() && r[i]();
    };
  }

  function se() {
    var e,
        t,
        n,
        r = {
      isUrlYoutubeOne: function isUrlYoutubeOne(e) {
        var t = document.createElement("a");
        return t.href = e, "www.youtube.com" === t.hostname;
      },
      getTypeFromResponseContentType: function getTypeFromResponseContentType(e) {
        return e.slice(0, e.indexOf("/"));
      }
    };

    function o() {
      if (4 !== n.readyState) {
        if (2 === n.readyState) {
          var e;

          switch (r.getTypeFromResponseContentType(n.getResponseHeader("content-type"))) {
            case "image":
              e = "image";
              break;

            case "video":
              e = "video";
              break;

            default:
              e = "invalid";
          }

          n.onreadystatechange = null, n.abort(), t(e);
        }
      } else t("invalid");
    }

    this.setUrlToCheck = function (t) {
      e = t;
    }, this.getSourceType = function (i) {
      if (r.isUrlYoutubeOne(e)) return i("youtube");
      t = i, (n = new XMLHttpRequest()).onreadystatechange = o, n.open("GET", e, !0), n.send();
    };
  }

  function ce(e, t, n) {
    var r = e.props,
        o = r.types,
        i = r.type,
        a = r.sources,
        s = e.resolve;
    this.getTypeSetByClientForIndex = function (e) {
      var t;
      return o && o[e] ? t = o[e] : i && (t = i), t;
    }, this.retrieveTypeWithXhrForIndex = function (e) {
      var r = s(se);
      r.setUrlToCheck(a[e]), r.getSourceType(function (r) {
        t.handleReceivedSourceTypeForUrl(r, a[e]), n.runActionsForSourceTypeAndIndex(r, e);
      });
    };
  }

  function le(e, t) {
    var n = e.current.classList;
    n.contains(t) && n.remove(t);
  }

  function ue(e) {
    var t = e.core,
        n = t.lightboxCloser,
        r = t.fullscreenToggler,
        o = t.slideChangeFacade;

    this.listener = function (e) {
      switch (e.key) {
        case "Escape":
          n.closeLightbox();
          break;

        case "ArrowLeft":
          o.changeToPrevious();
          break;

        case "ArrowRight":
          o.changeToNext();
          break;

        case "F11":
          e.preventDefault(), r.enterFullscreen();
      }
    };
  }

  function de(e) {
    return e.touches ? e.touches[0].screenX : e.screenX;
  }

  function fe(e) {
    var t = e.collections.sourceMainWrapperTransformers,
        n = e.componentsServices,
        r = e.elements.container,
        o = e.slideSwipingProps,
        a = e.stageIndexes;

    this.runActionsForEvent = function (e) {
      n.showSlideSwipingHovererIfNotYet(), r.current.classList.add(i), o.swipedX = de(e) - o.downScreenX, s(a.current, "zero"), void 0 !== a.previous && o.swipedX > 0 ? s(a.previous, "negative") : void 0 !== a.next && o.swipedX < 0 && s(a.next, "positive");
    };

    var s = function s(e, n) {
      t[e].byValue(o.swipedX)[n]();
    };
  }

  function pe(e) {
    var t,
        n = e.props.sources,
        r = e.resolve,
        o = e.slideSwipingProps,
        i = r(fe),
        a = (t = !1, function () {
      return !t && (t = !0, requestAnimationFrame(function () {
        t = !1;
      }), !0);
    });
    1 === n.length ? this.listener = function () {
      o.swipedX = 1;
    } : this.listener = function (e) {
      o.isSwiping && a() && i.runActionsForEvent(e);
    };
  }

  function he(e) {
    var t = e.collections.sourceMainWrapperTransformers,
        n = e.core.slideIndexChanger,
        r = e.elements.sourceMainWrappers,
        o = e.stageIndexes;
    this.runPositiveSwipedXActions = function () {
      void 0 === o.previous || (i("positive"), n.changeTo(o.previous)), i("zero");
    }, this.runNegativeSwipedXActions = function () {
      void 0 === o.next || (i("negative"), n.changeTo(o.next)), i("zero");
    };

    var i = function i(e) {
      r[o.current].current.classList.add(l), t[o.current][e]();
    };
  }

  function ge(e) {
    var t = e.componentsServices,
        n = e.core.lightboxCloser,
        r = e.elements.container,
        o = e.resolve,
        a = e.slideSwipingProps,
        s = o(he);
    this.runNoSwipeActions = function () {
      t.hideSlideSwipingHovererIfShown(), a.isSourceDownEventTarget || n.closeLightbox(), a.isSwiping = !1;
    }, this.runActions = function () {
      a.swipedX > 0 ? s.runPositiveSwipedXActions() : s.runNegativeSwipedXActions(), t.hideSlideSwipingHovererIfShown(), r.current.classList.remove(i), a.isSwiping = !1;
    };
  }

  function me(e) {
    var t = e.resolve,
        n = e.slideSwipingProps,
        r = t(ge);

    this.listener = function () {
      n.isSwiping && (n.swipedX ? r.runActions() : r.runNoSwipeActions());
    };
  }

  function ve(e) {
    return !e.touches || e.touches.length <= 1;
  }

  function be(e) {
    var t = e.core.classFacade,
        n = e.elements.sources,
        r = e.slideSwipingProps,
        o = e.stageIndexes;

    this.runActions = function (e) {
      "VIDEO" === e.target.tagName || e.touches || e.preventDefault(), r.isSwiping = !0, r.downScreenX = de(e), r.swipedX = 0;
      var i = n[o.current].current;
      i && i.contains(e.target) ? r.isSourceDownEventTarget = !0 : r.isSourceDownEventTarget = !1, t.removeFromEachElementClassIfContains("sourceMainWrappers", l);
    };
  }

  function xe(e) {
    var t, n, r;
    n = (t = e).core.classFacade, r = t.elements, n.removeFromEachElementClassIfContains = function (e, t) {
      for (var n = 0; n < r[e].length; n++) {
        le(r[e][n], t);
      }
    }, function (e) {
      var t = e.core.eventsDispatcher,
          n = e.props;

      t.dispatch = function (e) {
        n[e] && n[e]();
      };
    }(e), function (e) {
      var t = e.componentsServices.toolbarButtons.fullscreen,
          n = e.core.fullscreenToggler;
      n.enterFullscreen = function () {
        t.set(!0);
        var e = document.documentElement;
        e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
      }, n.exitFullscreen = function () {
        t.set(!1), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
      };
    }(e), function (e) {
      var t,
          n = e.core,
          r = n.globalEventsController,
          o = n.windowResizeActioner,
          i = e.resolve,
          a = i(ue),
          s = i(pe),
          c = i(me);
      r.attachListeners = function () {
        t = function (e, t) {
          return function () {
            t.apply(void 0, arguments) && e.apply(void 0, arguments);
          };
        }(s.listener, ve), document.addEventListener("mousemove", s.listener), document.addEventListener("touchmove", t, {
          passive: !0
        }), document.addEventListener("mouseup", c.listener), document.addEventListener("touchend", c.listener, {
          passive: !0
        }), addEventListener("resize", o.runActions), document.addEventListener("keydown", a.listener);
      }, r.removeListeners = function () {
        document.removeEventListener("mousemove", s.listener), document.removeEventListener("touchmove", t), document.removeEventListener("mouseup", c.listener), document.removeEventListener("touchend", c.listener), removeEventListener("resize", o.runActions), document.removeEventListener("keydown", a.listener);
      };
    }(e), function (e) {
      var t = e.core,
          n = t.lightboxCloser,
          r = t.lightboxCloseActioner;

      n.closeLightbox = function () {
        r.isLightboxFadingOut || r.runActions();
      };
    }(e), function (e) {
      var t = e.componentsServices,
          n = t.toolbarButtons.fullscreen,
          r = t.isLightboxOpenManager,
          o = e.core,
          i = o.eventsDispatcher,
          a = o.fullscreenToggler,
          s = o.globalEventsController,
          l = o.lightboxCloseActioner,
          u = o.scrollbarRecompensor,
          d = e.elements.container,
          f = e.props,
          p = e.slideSwipingProps,
          g = e.timeout;
      l.isLightboxFadingOut = !1, l.runActions = function () {
        l.isLightboxFadingOut = !0, d.current.classList.add(h), s.removeListeners(), f.exitFullscreenOnClose && n.get() && a.exitFullscreen(), g(function () {
          l.isLightboxFadingOut = !1, p.isSwiping = !1, d.current.classList.remove(h), document.documentElement.classList.remove(c), u.removeRecompense(), r.set(!1), i.dispatch("onClose");
        }, 250);
      };
    }(e), Oe(e), function (e) {
      var t = e.collections.sourceMainWrapperTransformers,
          n = e.core,
          r = n.eventsDispatcher,
          o = n.lightboxOpenActioner,
          i = n.globalEventsController,
          a = n.scrollbarRecompensor,
          s = n.sourceDisplayFacade,
          l = n.stageManager,
          u = n.windowResizeActioner,
          d = e.stageIndexes;

      o.runInitializedLightboxActions = function () {
        l.updateStageIndexes(), s.displaySourcesWhichShouldBeDisplayed(), document.documentElement.classList.add(c), a.addRecompense(), i.attachListeners(), u.runActions(), t[d.current].zero(), r.dispatch("onOpen");
      };
    }(e), J(e), function (e) {
      var t = e.data,
          n = e.core.scrollbarRecompensor;

      n.addRecompense = function () {
        "complete" === document.readyState ? r() : window.addEventListener("load", function () {
          r(), n.addRecompense = r;
        });
      };

      var r = function r() {
        document.body.offsetHeight > window.innerHeight && (document.body.style.marginRight = t.scrollbarWidth + "px");
      };

      n.removeRecompense = function () {
        document.body.style.removeProperty("margin-right");
      };
    }(e), function (e) {
      var t = e.core,
          n = t.slideChangeFacade,
          r = t.slideIndexChanger,
          o = t.stageManager;
      e.props.sources.length > 1 ? (n.changeToPrevious = function () {
        r.jumpTo(o.getPreviousSlideIndex());
      }, n.changeToNext = function () {
        r.jumpTo(o.getNextSlideIndex());
      }) : (n.changeToPrevious = function () {}, n.changeToNext = function () {});
    }(e), function (e) {
      var t = e.collections.sourceMainWrapperTransformers,
          n = e.componentsServices,
          r = e.core,
          o = r.classFacade,
          i = r.slideIndexChanger,
          a = r.sourceDisplayFacade,
          s = r.stageManager,
          c = e.elements.sourceAnimationWrappers,
          u = e.getQueuedAction,
          h = e.stageIndexes,
          g = e.timeout,
          m = u(function () {
        o.removeFromEachElementClassIfContains("sourceAnimationWrappers", f);
      }, 250);
      i.changeTo = function (e) {
        h.current = e, s.updateStageIndexes(), n.setSlideNumber(e + 1), a.displaySourcesWhichShouldBeDisplayed();
      }, i.jumpTo = function (e) {
        var n = h.current;
        i.changeTo(e), o.removeFromEachElementClassIfContains("sourceMainWrappers", l), le(c[n], p), le(c[n], d), c[n].current.classList.add(f), le(c[e], p), le(c[e], f), c[e].current.classList.add(d), m(), t[e].zero(), g(function () {
          n !== h.current && t[n].negative();
        }, 220);
      };
    }(e), function (e) {
      var t = e.core.slideSwipingDown,
          n = e.resolve,
          r = e.slideSwipingProps,
          o = n(be);

      t.listener = function (e) {
        e.touches && e.touches.length > 1 ? r.isSwiping = !1 : o.runActions(e);
      };
    }(e), function (e) {
      var t = e.core.sourceDisplayFacade,
          n = e.componentsServices.updateSourceDirectWrapperCollection,
          r = e.stageIndexes,
          o = e.props.loadOnlyCurrentSource;

      t.displaySourcesWhichShouldBeDisplayed = function () {
        if (o) n[r.current]();else for (var e in r) {
          void 0 !== r[e] && n[r[e]]();
        }
      };
    }(e), function (e) {
      var t = e.core.stageManager,
          n = e.props.sources,
          r = e.stageIndexes,
          o = n.length - 1;
      t.getPreviousSlideIndex = function () {
        return 0 === r.current ? o : r.current - 1;
      }, t.getNextSlideIndex = function () {
        return r.current === o ? 0 : r.current + 1;
      }, t.updateStageIndexes = 0 === o ? function () {} : 1 === o ? function () {
        0 === r.current ? (r.next = 1, delete r.previous) : (r.previous = 0, delete r.next);
      } : function () {
        r.previous = t.getPreviousSlideIndex(), r.next = t.getNextSlideIndex();
      }, t.isSourceInStage = o <= 2 ? function () {
        return !0;
      } : function (e) {
        var t = r.current;
        if (0 === t && e === o || t === o && 0 === e) return !0;
        var n = t - e;
        return -1 === n || 0 === n || 1 === n;
      };
    }(e), function (e) {
      var t = e.collections,
          n = t.sourceMainWrapperTransformers,
          r = t.sourceSizers,
          o = e.core.windowResizeActioner,
          i = e.data,
          a = e.elements,
          s = a.sources,
          c = a.sourceMainWrappers,
          u = e.stageIndexes;

      o.runActions = function () {
        innerWidth < 992 ? i.maxSourceWidth = innerWidth : i.maxSourceWidth = .9 * innerWidth, i.maxSourceHeight = .9 * innerHeight;

        for (var e = 0; e < s.length; e++) {
          le(c[e], l), e !== u.current && n[e].negative(), r[e] && s[e].current && r[e].adjustSize();
        }
      };
    }(e);
  }

  function ye(e) {
    for (var t = e.props.sources, n = [], r = 0; r < t.length; r++) {
      n.push(S.a.createRef());
    }

    return n;
  }

  function Se(e, t, n) {
    for (var r = 0; r < e.props.sources.length; r++) {
      e.collections[t][r] = e.resolve(n, [r]);
    }
  }

  function we(e, t) {
    var n = this,
        r = e.elements.sourceMainWrappers,
        o = e.props.slideDistance + 1,
        i = 0;
    this.byValue = function (e) {
      return i = e, n;
    }, this.negative = function () {
      a(-s());
    }, this.zero = function () {
      a(0);
    }, this.positive = function () {
      a(s());
    };

    var a = function a(e) {
      r[t].current.style.transform = "translateX(".concat(e + i, "px)"), i = 0;
    },
        s = function s() {
      return o * innerWidth;
    };
  }

  function Le(e, t, n, r) {
    var o = e.data,
        i = e.elements.sources,
        a = n / r,
        s = 0;

    this.adjustSize = function () {
      if ((s = o.maxSourceWidth / a) < o.maxSourceHeight) return n < o.maxSourceWidth && (s = r), c();
      s = r > o.maxSourceHeight ? o.maxSourceHeight : r, c();
    };

    var c = function c() {
      var e = i[t].current.style;
      e.width = s * a + "px", e.height = s + "px";
    };
  }

  function Ae(e, t) {
    var n = this,
        r = e.collections.sourceSizers,
        o = e.componentsServices.hideSourceLoaderCollection,
        i = e.elements,
        a = i.sourceAnimationWrappers,
        s = i.sources,
        c = e.resolve;

    function l(e, n) {
      r[t] = c(Le, [t, e, n]), r[t].adjustSize();
    }

    this.runActions = function (e, r) {
      s[t].current.classList.add(g), a[t].current.classList.add(p), o[t](), l(e, r), n.runActions = l;
    };
  }

  function Ee(e, t) {
    var n,
        r = this,
        o = e.elements.sources,
        i = e.props,
        a = e.resolve,
        s = e.timeout,
        c = a(Ae, [t]);
    this.handleImageLoad = function (e) {
      var t = e.target,
          n = t.naturalWidth,
          r = t.naturalHeight;
      c.runActions(n, r);
    }, this.handleVideoLoad = function (e) {
      var t = e.target,
          r = t.videoWidth,
          o = t.videoHeight;
      n = !0, c.runActions(r, o);
    }, this.handleNotMetaDatedVideoLoad = function () {
      n || r.handleYoutubeLoad();
    }, this.handleYoutubeLoad = function () {
      var e = 1920,
          t = 1080;
      i.maxYoutubeVideoDimensions && (e = i.maxYoutubeVideoDimensions.width, t = i.maxYoutubeVideoDimensions.height), c.runActions(e, t);
    }, this.handleCustomLoad = function () {
      s(function () {
        var e = o[t].current;
        c.runActions(e.offsetWidth, e.offsetHeight);
      });
    };
  }

  function Oe(e) {
    var t = e.componentsServices.isLightboxOpenManager,
        n = e.core,
        r = n.eventsDispatcher,
        o = n.lightboxOpener,
        i = n.lightboxOpenActioner,
        a = e.data,
        s = e.elements;
    o.openLightbox = function () {
      r.dispatch("onShow"), Se(e, "sourceLoadHandlers", Ee), t.set(!0, i.runInitializedLightboxActions);
    }, o.initializeAndOpenLightbox = function () {
      a.isInitialized = !0, s.sourceAnimationWrappers = ye(e), s.sourceMainWrappers = ye(e), s.sources = ye(e), Se(e, "sourceLoadHandlers", Ee), Se(e, "sourceMainWrapperTransformers", we), xe(e), r.dispatch("onInit"), t.set(!0, function () {
        i.runInitializedLightboxActions(), function (e) {
          for (var t = e.props.sources, n = e.resolve, r = n(G), o = n(ae), i = n(ce, [r, o]), a = 0; a < t.length; a++) {
            if ("string" == typeof t[a]) {
              var s = i.getTypeSetByClientForIndex(a);
              if (s) o.runActionsForSourceTypeAndIndex(s, a);else {
                var c = r.getSourceTypeFromLocalStorageByUrl(t[a]);
                c ? o.runActionsForSourceTypeAndIndex(c, a) : i.retrieveTypeWithXhrForIndex(a);
              }
            } else o.runActionsForSourceTypeAndIndex("custom", a);
          }
        }(e);
      });
    };
  }

  function Ce(e) {
    return (Ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Ie(e, t, n) {
    return (Ie = ke() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && ze(o, n.prototype), o;
    }).apply(null, arguments);
  }

  function Fe(e) {
    return function (e) {
      if (Array.isArray(e)) return Te(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Te(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Te(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Te(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function je(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function ze(e, t) {
    return (ze = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Me(e, t) {
    return !t || "object" !== Ce(t) && "function" != typeof t ? We(e) : t;
  }

  function We(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function ke() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function Ne(e) {
    return (Ne = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var De = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && ze(e, t);
    }(l, e);
    var t,
        n,
        o,
        i,
        s,
        c = (t = l, n = ke(), function () {
      var e,
          r = Ne(t);

      if (n) {
        var o = Ne(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);

      return Me(this, e);
    });

    function l(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), (t = c.call(this, e)).state = {
        isOpen: !1
      }, t.data = {
        isInitialized: !1,
        maxSourceWidth: 0,
        maxSourceHeight: 0,
        scrollbarWidth: 0
      }, t.slideSwipingProps = {
        isSwiping: !1,
        downScreenX: null,
        isSourceDownEventTarget: !1,
        swipedX: 0
      }, t.stageIndexes = {
        current: 0
      }, t.componentsServices = {
        showSlideSwipingHovererIfNotYet: null,
        hideSlideSwipingHovererIfShown: null,
        setSlideNumber: null,
        isSlideSwipingHovererShown: {},
        isFullscreenOpen: {},
        hideSourceLoaderCollection: [],
        updateSourceDirectWrapperCollection: [],
        toolbarButtons: {
          fullscreen: {}
        },
        isLightboxOpenManager: {
          get: function get() {
            return t.state.isOpen;
          },
          set: function set(e, n) {
            t.setState({
              isOpen: e
            }, n);
          }
        }
      }, t.elements = {
        container: S.a.createRef(),
        sourceMainWrappersWrapper: S.a.createRef(),
        sources: null,
        sourceMainWrappers: null,
        sourceAnimationWrappers: null,
        sourcesComponents: []
      }, t.collections = {
        sourceMainWrapperTransformers: [],
        sourceLoadHandlers: [],
        sourceSizers: [],
        xhrs: []
      }, t.core = {
        classFacade: {},
        eventsDispatcher: {},
        fullscreenToggler: {},
        globalEventsController: {},
        lightboxCloser: {},
        lightboxCloseActioner: {},
        lightboxOpener: {},
        lightboxOpenActioner: {},
        lightboxUpdater: {},
        scrollbarRecompensor: {},
        slideChangeFacade: {},
        slideIndexChanger: {},
        slideSwipingDown: {},
        sourceDisplayFacade: {},
        stageManager: {},
        windowResizeActioner: {}
      }, t.getQueuedAction = t.getQueuedAction.bind(We(t)), t.resolve = t.resolve.bind(We(t)), t.timeout = t.timeout.bind(We(t)), J(We(t)), Oe(We(t)), t;
    }

    return o = l, (i = [{
      key: "getQueuedAction",
      value: function value(e, t) {
        var n = this,
            r = [];
        return function () {
          r.push(!0), n.timeout(function () {
            r.pop(), r.length || e();
          }, t);
        };
      }
    }, {
      key: "resolve",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        return t.unshift(this), Ie(e, Fe(t));
      }
    }, {
      key: "timeout",
      value: function value(e, t) {
        var n = this;
        setTimeout(function () {
          n.elements.container.current && e();
        }, t);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t, n) {
        this.core.lightboxUpdater.handleUpdate(e);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        q(this);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        !function (e) {
          for (var t = e.collections.xhrs, n = e.componentsServices.isLightboxOpenManager, r = e.core.globalEventsController, o = 0; o < t.length; o++) {
            t[o].abort();
          }

          n.get() && r.removeListeners();
        }(this);
      }
    }, {
      key: "render",
      value: function value() {
        return this.state.isOpen ? S.a.createElement("div", {
          ref: this.elements.container,
          className: "".concat(r, "container ").concat(a, " ").concat(p)
        }, S.a.createElement(_, {
          fsLightbox: this
        }), S.a.createElement(W, {
          fsLightbox: this
        }), this.props.sources.length > 1 ? S.a.createElement(S.a.Fragment, null, S.a.createElement($, {
          onClick: this.core.slideChangeFacade.changeToPrevious,
          name: "previous",
          d: "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"
        }), S.a.createElement($, {
          onClick: this.core.slideChangeFacade.changeToNext,
          name: "next",
          d: "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z"
        })) : null, S.a.createElement(X, {
          fsLightbox: this
        })) : null;
      }
    }]) && je(o.prototype, i), s && je(o, s), l;
  }(y.Component);

  De.propTypes = {
    toggler: L.a.bool,
    sources: L.a.array,
    slide: L.a.number,
    source: L.a.string,
    sourceIndex: L.a.number,
    onOpen: L.a.func,
    onClose: L.a.func,
    onInit: L.a.func,
    onShow: L.a.func,
    disableLocalStorage: L.a.bool,
    types: L.a.array,
    type: L.a.string,
    customAttributes: L.a.array,
    maxYoutubeVideoDimensions: L.a.object,
    exitFullscreenOnClose: L.a.bool,
    loadOnlyCurrentSource: L.a.bool,
    openOnMount: L.a.bool,
    slideDistance: L.a.number
  }, De.defaultProps = {
    slideDistance: .3
  };
  t.default = De;
}]);